// Generated by purs version 0.13.8
"use strict";
var Data_Function = require("../Data.Function/index.js");
var Data_Symbol = require("../Data.Symbol/index.js");
var Lunarbox_Data_Dataflow_Runtime_Class_Describable = require("../Lunarbox.Data.Dataflow.Runtime.Class.Describable/index.js");
var Lunarbox_Data_Dataflow_Runtime_Class_Runnable = require("../Lunarbox.Data.Dataflow.Runtime.Class.Runnable/index.js");
var Lunarbox_Data_Dataflow_Runtime_Class_Typeable = require("../Lunarbox.Data.Dataflow.Runtime.Class.Typeable/index.js");
var Lunarbox_Data_Dataflow_Scheme = require("../Lunarbox.Data.Dataflow.Scheme/index.js");
var Lunarbox_Data_Dataflow_Type = require("../Lunarbox.Data.Dataflow.Type/index.js");
var Lunarbox_Data_Editor_FunctionData = require("../Lunarbox.Data.Editor.FunctionData/index.js");
var typeIf = (function () {
    var typeReturn = new Lunarbox_Data_Dataflow_Type.TVariable(true, "a");
    return Lunarbox_Data_Dataflow_Scheme.Forall.create([ "a" ])(Lunarbox_Data_Dataflow_Type.typeFunction(Lunarbox_Data_Dataflow_Type.typeBool)(Lunarbox_Data_Dataflow_Type.typeFunction(typeReturn)(Lunarbox_Data_Dataflow_Type.typeFunction(typeReturn)(typeReturn))));
})();
var if$prime = (function () {
    var evalIf = function (v) {
        if (v) {
            return Data_Function["const"];
        };
        if (!v) {
            return Data_Function.flip(Data_Function["const"]);
        };
        throw new Error("Failed pattern match at Lunarbox.Data.Dataflow.Native.ControlFlow (line 49, column 3 - line 49, column 41): " + [ v.constructor.name ]);
    };
    return {
        name: "if",
        expression: Lunarbox_Data_Dataflow_Runtime_Class_Describable.toNativeExpression(Lunarbox_Data_Dataflow_Runtime_Class_Describable.describableA(Lunarbox_Data_Dataflow_Runtime_Class_Describable.runnableDProxy(Lunarbox_Data_Dataflow_Runtime_Class_Runnable.runnableArrow(Lunarbox_Data_Dataflow_Runtime_Class_Runnable.corunnableBool)(Lunarbox_Data_Dataflow_Runtime_Class_Runnable.runnableArrow(Lunarbox_Data_Dataflow_Runtime_Class_Runnable.corunnaleRuntimeValue)(Lunarbox_Data_Dataflow_Runtime_Class_Runnable.runnableArrow(Lunarbox_Data_Dataflow_Runtime_Class_Runnable.corunnaleRuntimeValue)(Lunarbox_Data_Dataflow_Runtime_Class_Runnable.runnableRuntimeValue)))))(Lunarbox_Data_Dataflow_Runtime_Class_Describable.typeableDProxy(Lunarbox_Data_Dataflow_Runtime_Class_Typeable.typeableArrow(Lunarbox_Data_Dataflow_Runtime_Class_Typeable.typeableBool)(Lunarbox_Data_Dataflow_Runtime_Class_Typeable.typeableArrow(Lunarbox_Data_Dataflow_Runtime_Class_Typeable.typeableSymbol(new Data_Symbol.IsSymbol(function () {
            return "a";
        })))(Lunarbox_Data_Dataflow_Runtime_Class_Typeable.typeableArrow(Lunarbox_Data_Dataflow_Runtime_Class_Typeable.typeableSymbol(new Data_Symbol.IsSymbol(function () {
            return "a";
        })))(Lunarbox_Data_Dataflow_Runtime_Class_Typeable.typeableSymbol(new Data_Symbol.IsSymbol(function () {
            return "a";
        }))))))))(evalIf),
        functionData: Lunarbox_Data_Editor_FunctionData.internal([ {
            name: "condition",
            description: "A boolean which decides what branch to evaluate to"
        }, {
            name: "then",
            description: "A branch which will be chosem if the condition is true"
        }, {
            name: "else",
            description: "A branch which will be chosen if the condition is false"
        } ])({
            name: "result",
            description: "Evaluates to the 'then' argument if the condition is true, else this evaludates to the 'else' argument"
        })
    };
})();
var controlFlowNodes = [ if$prime ];
module.exports = {
    controlFlowNodes: controlFlowNodes
};
